export default "__VITE_ASSET__DRmH7Zs3__"